export function getTranslationDashboardElements() {
  const websiteSelect = document.getElementById('websiteSelect')
  const sectionSelect = document.getElementById('dynamicPartSelect')
  const buSelect = document.getElementById('pagePropertyInput')
  const itemsPerPageSelect = document.getElementById('itemsPerPage')
  const searchButton = document.querySelector('.cmp-button__translation-search')
  const searchWrapper = document.querySelector('.cmp-translation-search-wrapper-input')
  const searchInput = document.querySelector('.cmp-translation-search-input')
  const sortButtons = document.querySelectorAll('.cmp-filterable-list__table--sortable-button[data-column][data-order-type]')
  const statusAllRadio = document.querySelector('input[name="translate_status"][value="all"]')
  const TD_DROPDOWN_SELECTOR = '.td-dropdown'
  const TD_DROPDOWN_MENU_SELECTOR = '.td-dropdown__menu'
  const TD_DROPDOWN_TEXT_SELECTOR = '.td-dropdown__text'
  const TD_DROPDOWN_ITEM_CLASS = 'td-dropdown__item'
  const DATA_VALUE_ATTRIBUTE = 'data-value'
  return {
    websiteSelect,
    sectionSelect,
    buSelect,
    itemsPerPageSelect,
    searchButton,
    searchWrapper,
    searchInput,
    sortButtons,
    statusAllRadio,
    TD_DROPDOWN_SELECTOR,
    TD_DROPDOWN_MENU_SELECTOR,
    TD_DROPDOWN_TEXT_SELECTOR,
    TD_DROPDOWN_ITEM_CLASS,
    DATA_VALUE_ATTRIBUTE,
  }
}
